
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

export const MESSAGES_DYNAMIC = defineMessages({
  trough: {
    id: "Warning.RequireReset.Trough",
    defaultMessage: "Due to changes to your configuration, if you want to choose a new trough and increase or decrease the quantity, all listed items has to be reset:",
  },
  qty: {
    id: "Warning.RequireReset.Qty",
    defaultMessage: "Due to changes to your configuration, if you want to increase or decrease the quantity, all listed items has to be reset:",
  },
  typeOfInstallation: {
    id: "Warning.RequireReset.TypeOfInstallation",
    defaultMessage: "Due to changes to your configuration, if you want to change the type of the installation, all listed items has to be reset:",
  },
  plateWidth: {
    id: "Warning.RequireReset.plateWidth",
    defaultMessage: "Due to changes to your configuration, if you want to change the plate width, all listed items has to be reset:",
  },
  plateDepth: {
    id: "Warning.RequireReset.PlateDepth",
    defaultMessage: "Due to changes to your configuration, if you want to change the plate depth, all listed items has to be reset:",
  },
  distances: {
    id: "Warning.RequireReset.distances",
    defaultMessage: "Due to changes to your configuration, if you want to change the distances, all listed items has to be reset:",
  },
  cornerDesign: {
    id: "Warning.RequireReset.cornerDesign",
    defaultMessage: "Due to changes to your configuration, if you want to change the corner design, all listed items has to be reset:",
  }
});

export const MESSAGES_DEFAULTS = defineMessages({
  requireReset: {
    id: "Warning.RequireReset",
    defaultMessage: "Reset required: ",
  }, 
  requireResetDefault: {
    id: "Warning.RequireReset.Default",
    defaultMessage: "Due to changes to your configuration you need to reset it."
  },
  requireResetContinue: {
    id: "Warning.RequireReset.ResetAll",
    defaultMessage: "Reset all?",
  }, 
  console: {
    id: "Warning.RequireReset.console",
    defaultMessage: "Consoles",
  },
  cornerDesign: {
    id: "Warning.RequireReset.cornerDesign",
    defaultMessage: "Corner design",
  },
  qty: {
    id: "Warning.RequireReset.qty",
    defaultMessage: "Trough quantity",
  },
  distances: {
    id: "Warning.RequireReset.distances",
    defaultMessage: "Distances",
  },
  drain: {
    id: "Warning.RequireReset.drain",
    defaultMessage: "Drain Accessories",
  }, 
  typeOfInstallation: {
    id: "Warning.RequireReset.typeOfInstallation",
    defaultMessage: "Type of installation"
  },
  paperTowelDispensers: {
    id: "Warning.RequireReset.paperTowelDispensers",
    defaultMessage: "Cut out for towel dispenser",
  },
  plateDepth: {
    id: "Warning.RequireReset.plateDepth",
    defaultMessage: "Plate depth",
  }, 
  plateWidth: {
    id: "Warning.RequireReset.plateWidth",
    defaultMessage: "Plate width",
  },
  siphon: {
    id: "Warning.RequireReset.siphon",
    defaultMessage: "Siphon",
  }, 
  soapDispenserHole: {
    id: "Warning.RequireReset.soapDispenserHole",
    defaultMessage: "Drill hole for soap dispenser.",
  },
  tapHole: {
    id: "Warning.RequireReset.tapHole",
    defaultMessage: "Drill hole for tap",
  }, 
  tissueDispenser: {
    id: "Warning.RequireReset.tissueDispenser",
    defaultMessage: "Cut out for tissue dispenser",
  },
  apron: {
    id: "Warning.RequireReset.apron",
    defaultMessage: "Apron",
  },
  surgeEdgeOrBackSplash: {
    id: "Warning.RequireReset.surgeEdgeOrBackSplash",
    defaultMessage: "Surge edge / Splashback"
  },
  cutOutDisposals: {
    id: "Warning.RequireReset.cutOutDisposals",
    defaultMessage: "Cut out disposals"
  }
});

const MESSAGES = {
  dynamic : MESSAGES_DYNAMIC,
  defaults: MESSAGES_DEFAULTS,
};

export default MESSAGES;